import axios from "axios";

export default axios.create({
  // baseURL: `/api`,
  baseURL: `https://api3.up-it.rs/api`,
  withCredentials: true,
  headers: {
    Authorization: "a762bd71-b77c-4c1e-9ebc-7d77ddf94674",
  },
});
